import {useEffect} from 'react';

// disables page scroll when filters modal is open on mobile and tablet
const disablePageScroll = (modalIsOpen) => {
	useEffect(() => {
		const body = document.body;
		if (modalIsOpen === true) {
			body.classList.add('js-lock-body');
		} else {
			body.classList.remove('js-lock-body');
		}
	}, [modalIsOpen]);
};

export default disablePageScroll;